import React, { useState, useEffect } from 'react';
import ModalVideo from 'react-modal-video';
import axios from '../../api/axios';
import ImageWithPlayIcon from "../Shared/ImageWithPlayIcon";

import { Link } from 'react-router-dom';
import { AiOutlinePlayCircle } from 'react-icons/ai';

import LocalizedStrings from 'react-localization';
import localeFile from '../../local/content';

import { connect } from 'react-redux';
const strings = new LocalizedStrings(localeFile);

const EventSchedulesFour = (props) => {
    const [resources, setResources] = useState([]);
    const [resourcespdfs, setResourcesPdfs] = useState([]);
    const [resourcesvideos, setResourcesVideos] = useState([]);
    const [resourcespodcasts, setResourcesPodcasts] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [url, setUrl] = useState('');

    useEffect(() => {
        axios.get(`get_ressources`)
            .then(res => {
                const resources = res.data.resource;
                setResources(resources);
            });
    }, []);

    const openTabSection = (evt, tabName) => {
        let i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabs_item");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        tablinks = document.getElementsByTagName("li");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace("current", "");
        }

        document.getElementById(tabName).style.display = "block";
        evt.currentTarget.className += "current";
    };

    const openModal = (url) => {
        setUrl(url);
        setIsOpen(true);
    };

    strings.setLanguage(props.languageCode);

    return (
        <section className="schedule-area schedule-style-four bg-image ptb-120">
            <ModalVideo
                channel='youtube'
                autoplay
                isOpen={isOpen}
                videoId={url}
                onClose={() => setIsOpen(false)}
                loading={() => <div>{strings.Loading}</div>}
            />
            <div className="container">
                <div className="section-title">
                    <div className="bar"></div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tab">
                            <div className="row">
                                {strings.hreflangCode === 'ar' && (
                                    <div className="col-lg-4 col-md-3">
                                        <ul className="tabs active">
                                            <li onClick={(e) => openTabSection(e, 'tab1')} className="current">
                                                <Link to="#">
                                                    {strings.GUIDE}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab2')}>
                                                <Link to="#">
                                                    {strings.list}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab3')}>
                                                <Link to="#">
                                                    {strings.video}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                <div className="col-lg-8 col-md-9">
                                    <div className="tab_content">
                                        <div id="tab1" className="tabs_item">
                                            <ul className="accordion">
                                                {resources.length > 0 && (
                                                    resources.map((resource, index) => {
                                                        if (resource.urlpdf != null) {
                                                            return (
                                                                <li className="accordion-item" key={index}>
                                                                    <div className="accordion-title">
                                                                        <div className="author">
                                                                            <img
                                                                                src={`https://dashboardawledna.futurevisions.tn/${resource.image}`}
                                                                                data-toggle="tooltip"
                                                                                data-placement="top"
                                                                                alt="Img"
                                                                            />
                                                                        </div>
                                                                        <div className="schedule-info mx-3">
                                                                            <h3>{strings.hreflangCode === 'fr' ? resource.titre :strings.hreflangCode === 'ar' ?  resource.titre_arabe :resource.titre_eng}</h3>
                                                                            <ul>
                                                                                <li>
                                                                                    <a href={`https://dashboardawledna.futurevisions.tn/${resource.urlpdf}`} download>
                                                                                        <span>{strings.Télécharger}</span>
                                                                                        <i className="icofont-download"></i>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                )}
                                            </ul>
                                        </div>
                                        <div id="tab2" className="tabs_item">
                                              

                                        <h2> {strings.list}</h2>

                                        <table >
                                            <thead>
                                            <tr >
                                                <th> {strings.valeurDinar} </th>
                                                <th>{strings.funder}</th>
                                                <th>{strings.year}</th>
                                                <th>{strings.topic}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td dir='ltr' >10 000</td>
                                                <td>منظمة أنا يقظ - I WATCH Organization </td>
                                                <td>2019</td>
                                                <td>ملاحظة الانتخابات التشريعية والرئاسية لسنة 2019</td>
                                            </tr>
                                            <tr>
                                                <td dir='ltr' >10 000</td>
                                                <td>منظمة أنا يقظ - I WATCH </td>
                                                <td>2019</td>
                                                <td>ملاحظة الانتخابات التشريعية والرئاسية لسنة 2019</td>
                                            </tr>
                                            </tbody>
                                        </table>

                                            {/* partie ressource PODCAST */}
                                            {/* <ul className="accordion">
                                                {resources.length > 0 && (
                                                    resources.map((podcast, index) => {
                                                        if (podcast.podcast != null) {
                                                            return (
                                                                <li className="accordion-item" key={index}>
                                                                    <Link className="accordion-title" to="#">
                                                                        <div className="author-vd">
                                                                            <Link to="#" onClick={() => openModal(podcast.video)}>
                                                                                <ImageWithPlayIcon src={`http://admin.futurevisions.tn/${podcast.image}`} />
                                                                            </Link>
                                                                            <div className='icon-play-vd'>
                                                                                <AiOutlinePlayCircle size={'50px'} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="schedule-info mx-3">
                                                                            <h3>{strings.hreflangCode === 'fr' ? podcast.titre :strings.hreflangCode === 'ar' ?  podcast.titre_arabe : podcast.titre_eng}</h3>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                )}
                                            </ul> */}
                                        </div>
                                        <div id="tab3" className="tabs_item">
                                            <ul className="accordion">
                                                {resources.length > 0 && (
                                                    resources.map((resource, index) => {
                                                        if (resource.video != null) {
                                                            return (
                                                                <li className="accordion-item" key={index}>
                                                                    <Link className="accordion-title" to="#">
                                                                        <div className="author-vd">
                                                                            <Link to="#" onClick={() => openModal(resource.video)}>
                                                                                <ImageWithPlayIcon src={`http://admin.futurevisions.tn/${resource.image}`} />
                                                                            </Link>
                                                                            <div className='icon-play-vd'>
                                                                                <AiOutlinePlayCircle size={'50px'} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="schedule-info mx-3">
                                                                            <h3>{strings.hreflangCode === 'fr' ? resource.titre :strings.hreflangCode === 'ar' ? resource.titre_arabe:resource.titre_eng}</h3>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {strings.hreflangCode === 'fr' && (
                                    <div className="col-lg-4 col-md-3">
                                        <ul className="tabs active">
                                            <li onClick={(e) => openTabSection(e, 'tab1')} className="current">
                                                <Link to="#">
                                                    {strings.GUIDE}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab2')}>
                                                <Link to="#">
                                                    {strings.list}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab3')}>
                                                <Link to="#">
                                                    {strings.video}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                {strings.hreflangCode === 'en' && (
                                    <div className="col-lg-4 col-md-3">
                                        <ul className="tabs active">
                                            <li onClick={(e) => openTabSection(e, 'tab1')} className="current">
                                                <Link to="#">
                                                    {strings.GUIDE}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab2')}>
                                                <Link to="#">
                                                    {strings.list}
                                                </Link>
                                            </li>
                                            <li onClick={(e) => openTabSection(e, 'tab3')}>
                                                <Link to="#">
                                                    {strings.video}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
             
            </div>
        </section>
    );
};

const mapStateToProps = state => {
    return {
        languageCode: state.languageCode
    }
}

export default connect(mapStateToProps)(EventSchedulesFour);
